// NavBar.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import { motion } from 'framer-motion';
import { FaBars, FaTimes } from 'react-icons/fa';

const NavBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Close the mobile menu when resizing to a larger screen
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768 && isMenuOpen) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
      className="navbar"
    >
      {/* Logo */}
      <div className="navbar__logo">
        <Link
          to="home"
          smooth={true}
          duration={500}
          className="navbar__logo-link"
        >
          Bhagya Trivedi
        </Link>
      </div>

      {/* Hamburger Menu Icon */}
      <div
        className="navbar__menu-icon"
        onClick={toggleMenu}
        aria-label="Toggle navigation menu"
        aria-expanded={isMenuOpen}
      >
        {isMenuOpen ? <FaTimes /> : <FaBars />}
      </div>

      {/* Navigation Links (Mobile) */}
      <div className={`navbar__links-mobile ${isMenuOpen ? 'active' : ''}`}>
        {['Home', 'About', 'Skills', 'Experience', 'Projects', 'Testimonials', 'Contact'].map((item) => (
          <Link
            key={item}
            to={item.toLowerCase()}
            smooth={true}
            duration={500}
            onClick={() => setIsMenuOpen(false)}
            className="navbar__link"
          >
            {item}
          </Link>
        ))}
      </div>

      {/* Navigation Links (Desktop) */}
      <div className="navbar__links-desktop">
        {['Home', 'About', 'Skills', 'Experience', 'Projects', 'Testimonials', 'Contact'].map((item) => (
          <Link
            key={item}
            to={item.toLowerCase()}
            smooth={true}
            duration={500}
            className="navbar__link"
          >
            {item}
          </Link>
        ))}
      </div>
    </motion.nav>
  );
};

export default NavBar;
